import { StateParams, StateService } from "@uirouter/angularjs";
import {NotificationService} from "../../services/NotificationService";
import { FileDataService } from "../../services/FileDataService";

export class AssetPictureCtrl {
    $scope:any;
    b64String:any;
    public static $inject = ['$window','$scope','$state','$stateParams','NotificationService','FileDataService'];
    constructor(public $window:Window,
                $scope:any,
                public stateService:StateService,
                public stateParamsService:StateParams,                
        public notifyService: NotificationService,
        public fileDataService: FileDataService) {
        this.$scope = $scope;
        $scope.vm = this;
        var id: number = parseInt(this.stateParamsService["id"]);
        if (isNaN(id))
            id = null;
        this.fileDataService.get(id).then(b64Str => {
            this.b64String = b64Str;
        })
            .catch(exc => {
                this.notifyService.notifyError(exc.message);
        });
    }

    cancel() {        
        this.$window.close();
    }
    
}
